import Auth from './auth'
import Coupon from './coupon'

export default {
  Auth,
  Coupon
}
